import React, { useEffect, useState } from "react";
import CompanySelect from "../../../components/admin/usable/CompanySelect";
import EditorJSSingle from "../../../components/admin/usable/EditorJSSingle";
import { Switch } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import {
  setForAll,
  setShowFileUploader,
} from "../../../redux/admin/fileManagerSlice";
import FileUploadandSelect from "../../../components/admin/usable/fileuploader/FileUploadandSelect";
import AddButton from "../../../components/admin/usable/AddButton";
import CancelButton from "../../../components/admin/usable/CancelButton";
import {
  addTour,
  getTourDetails,
  updateTour,
} from "../../../api/admin/tourApi";
import { useNavigate, useParams } from "react-router";

const EditTour = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showFileUploader, multiSelected } = useSelector(
    (state) => state.file,
  );
  const [FormData, setFormData] = useState({
    id: "",
    tourName: "",
    companyId: "",
    city: "",
    division: "",
    country: "",
    startDate: "",
    endDate: "",
    minPeople: "",
    maxiPeople: "",
    price: "",
    discount: "",
    tax: "",
    cancelationPolicy: "",
    overview: "",
    includeOrexclude: "",
    description: "",
    additionalInformation: "",
    travelTips: "",
    others: "",
    isDhoorbinChoice: 0,
    isCustomerChoice: 0,
    isFeatured: 0,
    isCoupleFriendly: 0,
    isIdRequired: 0,
    status: 1,
    createdAt: new Date().toISOString(),
    images: [],
  });

  const [ImageFile, setImageFile] = useState([]);
  useEffect(() => {
    if (multiSelected && multiSelected.length > 0) {
      const newImages = multiSelected.map((item) => ({
        imageLink: item.fileLink.medium,
      }));

      setFormData((prev) => {
        const existingLinks = prev.images.map((img) => img.imageLink);

        const merged = [
          ...prev.images,
          ...newImages.filter((img) => !existingLinks.includes(img.imageLink)),
        ];

        return {
          ...prev,
          images: merged,
        };
      });

      setImageFile((prev) => {
        const existingLinks = prev.map((img) => img.imageLink);
        return [
          ...prev,
          ...newImages.filter((img) => !existingLinks.includes(img.imageLink)),
        ];
      });
    }
  }, [multiSelected]);
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      images: ImageFile,
    }));
  }, [ImageFile]);
  useEffect(() => {
    getTourDetails(id, setFormData, setImageFile);
  }, [id]);

  const handleUploadMulti = () => {
    dispatch(setShowFileUploader(true));
    dispatch(setForAll(true));
  };
  const handleRemoveImageLink = (link) => {
    setFormData((prev) => ({
      ...prev,
      images: prev.images.filter((img) => img.imageLink !== link),
    }));

    setImageFile((prev) => prev.filter((img) => img.imageLink !== link));
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  const handleChangeFeatures = (field) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: prevData[field] === 1 ? 0 : 1,
    }));
  };

  const handleSubmit = () => {
    updateTour(FormData, navigate);
  };
  return (
    <>
      {showFileUploader && <FileUploadandSelect />}

      <div className="space-y-5">
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase"> Tour Information</p>
          </div>
          <div className="grid grid-col-1 lg:grid-cols-2 gap-3">
            <div className="space-y-3">
              <div>
                <label className="text-xs">Tour Title</label>
                <input
                  type="text"
                  placeholder="Tour Title"
                  className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                  id="tourName"
                  value={FormData.tourName}
                  onChange={handleChange}
                />
              </div>
              <div className="grid grid-col-1 lg:grid-cols-3 gap-3">
                <div>
                  <label className="text-xs">City</label>
                  <input
                    type="text"
                    placeholder="City"
                    className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                    id="city"
                    value={FormData.city}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="text-xs">Division</label>
                  <input
                    type="text"
                    placeholder="Division"
                    className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                    id="division"
                    value={FormData.division}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label className="text-xs">Country</label>
                  <input
                    type="text"
                    placeholder="Country"
                    className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                    id="country"
                    value={FormData.country}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div>
                <label className="text-xs">Cancelation Policy</label>
                <textarea
                  rows={5}
                  type="text"
                  placeholder="Cancelation Policy"
                  className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                  id="cancelationPolicy"
                  value={FormData.cancelationPolicy}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div>
              <div className="space-y-3">
                <div>
                  <label className="text-xs">Select Company</label>
                  <CompanySelect
                    setCompanyId={(id) =>
                      setFormData({ ...FormData, companyId: id })
                    }
                    CompanyId={FormData.companyId}
                  />
                </div>
                <div className="grid grid-col-1 lg:grid-cols-2 gap-3">
                  <div>
                    <label className="text-xs">Start Date</label>
                    <input
                      type="date"
                      placeholder="Start Date"
                      className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                      id="startDate"
                      value={FormData.startDate}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <label className="text-xs">End Date</label>
                    <input
                      type="date"
                      placeholder="End Date"
                      className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                      id="endDate"
                      value={FormData.endDate}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="grid grid-col-1 lg:grid-cols-4 gap-3">
                  <div>
                    <label className="text-xs">Regular Price</label>
                    <input
                      type="number"
                      placeholder="Regular Price"
                      className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                      id="price"
                      value={FormData.price}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <label className="text-xs">Discount(%)</label>
                    <input
                      type="number"
                      placeholder="Discount(%)"
                      className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                      id="discount"
                      value={FormData.discount}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <label className="text-xs">TAX(%)</label>
                    <input
                      type="number"
                      placeholder="TAX(%)"
                      className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                      id="tax"
                      value={FormData.tax}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <label className="text-xs">Discounted Price</label>
                    <input
                      disabled
                      type="number"
                      placeholder="Discounted Price"
                      className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                    />
                  </div>
                </div>
                <div className="grid grid-col-1 lg:grid-cols-2 gap-3">
                  <div>
                    <label className="text-xs">Min Traveller</label>
                    <input
                      type="number"
                      placeholder="Min Traveller"
                      className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                      id="minPeople"
                      value={FormData.minPeople}
                      onChange={handleChange}
                    />
                  </div>
                  <div>
                    <label className="text-xs">Maximum Traveller</label>
                    <input
                      type="number"
                      placeholder="Maximum Traveller"
                      className="w-full px-4 py-2 text-sm rounded-lg border focus:outline-none"
                      id="maxiPeople"
                      value={FormData.maxiPeople}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg">
          <div>
            <p className="font-bold text-center uppercase">Tour Overview</p>
          </div>
          <label htmlFor="" className="text-xs">
            Overview
          </label>
          <textarea
            rows={6}
            className="w-full mt-2 border rounded-lg p-3 text-sm focus:outline-none"
            placeholder="Tour Overview"
            id="overview"
            value={FormData.overview}
            onChange={handleChange}
          ></textarea>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase"> Description</p>
          </div>
          <label htmlFor="" className="text-xs">
            Description
          </label>
          <EditorJSSingle
            content={FormData.description}
            setContent={(value) =>
              setFormData((prev) => ({
                ...prev,
                description: value,
              }))
            }
          />
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">
              Exclude and Include
            </p>
          </div>
          <label htmlFor="" className="text-xs">
            Exclude and Include
          </label>
          <EditorJSSingle
            content={FormData.includeOrexclude}
            setContent={(value) =>
              setFormData((prev) => ({
                ...prev,
                includeOrexclude: value,
              }))
            }
          />
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">
              Addition Information
            </p>
          </div>
          <label htmlFor="" className="text-xs">
            Additional Information
          </label>
          <EditorJSSingle
            content={FormData.additionalInformation}
            setContent={(value) =>
              setFormData((prev) => ({
                ...prev,
                additionalInformation: value,
              }))
            }
          />
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase"> Travel Tips</p>
          </div>
          <label htmlFor="" className="text-xs">
            Travel Tips
          </label>
          <EditorJSSingle
            content={FormData.travelTips}
            setContent={(value) =>
              setFormData((prev) => ({
                ...prev,
                travelTips: value,
              }))
            }
          />
        </div>

        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Others</p>
          </div>
          <label htmlFor="" className="text-xs">
            Others
          </label>
          <EditorJSSingle
            content={FormData.others}
            setContent={(value) =>
              setFormData((prev) => ({
                ...prev,
                others: value,
              }))
            }
          />
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Select Images</p>
          </div>
          <div>
            {FormData.images && FormData.images.length > 0 ? (
              <>
                <div className="flex justify-start flex-wrap items-center gap-3">
                  {FormData.images.map((item, index) => {
                    return (
                      <div key={index} className="relative w-28 h-28">
                        <img
                          className="w-28 h-28 object-cover rounded-lg"
                          src={
                            item.imageLink ||
                            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                          }
                          alt=""
                        />
                        {item.imageLink && (
                          <div
                            onClick={() =>
                              handleRemoveImageLink(item.imageLink)
                            }
                            className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full cursor-pointer z-30"
                          >
                            <p className="text-xs">Remove</p>
                          </div>
                        )}
                        <div
                          onClick={() => handleUploadMulti()}
                          className="opacity-0 hover:opacity-100 absolute inset-0 bg-black/20 px-3 py-1 border cursor-pointer flex justify-center items-center duration-300 rounded-lg w-28 h-28"
                        >
                          <p className="font-bold">Upload Now</p>
                        </div>
                      </div>
                    );
                  })}
                  <div>
                    <button
                      onClick={handleUploadMulti}
                      className="p-4 border w-28 h-28 flex justify-center items-center text-2xl font-bold bg-white rounded-lg hover:bg-[#d3e8ff] duration-300"
                    >
                      +
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div>
                  <button
                    onClick={handleUploadMulti}
                    className="p-4 border w-28 h-28 flex justify-center items-center text-2xl font-bold bg-white rounded-lg hover:bg-[#d3e8ff] duration-300"
                  >
                    +
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="p-4 bg-white rounded-lg space-y-3">
          <div>
            <p className="font-bold text-center uppercase">Features Toggle</p>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-4">
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Couple Friendly?
              </label>
              <div>
                <Switch
                  checked={FormData.isCoupleFriendly === 1}
                  onChange={() => handleChangeFeatures("isCoupleFriendly")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Featured?
              </label>
              <div>
                <Switch
                  checked={FormData.isFeatured === 1}
                  onChange={() => handleChangeFeatures("isFeatured")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                ID card required?
              </label>
              <div>
                <Switch
                  checked={FormData.isIdRequired === 1}
                  onChange={() => handleChangeFeatures("isIdRequired")}
                />
              </div>
            </div>

            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Dhoorbin choice?
              </label>
              <div>
                <Switch
                  checked={FormData.isDhoorbinChoice === 1}
                  onChange={() => handleChangeFeatures("isDhoorbinChoice")}
                />
              </div>
            </div>
            <div className="flex justify-start items-center gap-x-2 border p-2 rounded-lg cursor-pointer w-fit">
              <label htmlFor="" className="text-xs pb-2">
                Customer Choice allowed?
              </label>
              <div>
                <Switch
                  checked={FormData.isCustomerChoice === 1}
                  onChange={() => handleChangeFeatures("isCustomerChoice")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4 bg-white rounded-lg space-y-3">
        <div className="flex justify-center items-center gap-3">
          <AddButton onClick={handleSubmit} text="Update Tour" />
          <CancelButton text="Reset" />
        </div>
      </div>
    </>
  );
};

export default EditTour;
